import { PageScaffold } from "../../shared/ui/PageScaffold";

const adminLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/members", label: "メンバー" }
];

export function AdminStudentsPage() {
  return (
    <PageScaffold
      title="Admin Students"
      description="生徒一覧画面のプレースホルダーです。"
      links={adminLinks}
    >
      <p>ここに生徒一覧を表示します。</p>
    </PageScaffold>
  );
}
